import React, { useState } from "react";
import {
  Input,
  ErrorMessage,
  IconButton,
  UpgradeCard,
} from "../../../components";
import { InformationCircleIcon } from "@heroicons/react/solid";
import { FaAngleRight } from "react-icons/fa";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import {
  getStartedStep,
  getAllData,
} from "../../../redux/actions/premium/homeActions";
import authHeader from "../../../services/auth/auth-header";
import Axios from "axios";
import HelpButton from "../../../components/button/helpButton";

// get step data from redux main state
const data = (state) => state.premiumHome.step1Data;

const GetStartedStep = (props) => {
  let savedData = useSelector(data);
  const [assessmentName, setAssessmentName] = useState(
    savedData ? savedData.assessmentName : ""
  );
  const [jobType, setJobType] = useState(savedData ? savedData.jobType : []);
  const [errorShow, setErrorShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState(false);
  const [upgrade, setUpgrade] = useState(false);

  // update Plan

  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };

  const handleChange = (option) => {
    setJobType(option.target.value);
  };

  let handleNext = () => {
    if (!assessmentName) {
      setErrorShow(true);

      setErrorMessage("Assessment name required!");
    } else if (!jobType || jobType.length < 1) {
      setErrorShow(true);

      setErrorMessage("Job type required!");
    } else {
      setLoading(true);

      let bucketName =
        assessmentName &&
        assessmentName.toLowerCase().replace(/[^A-Za-z0-9]/g, "");
      let apiCall = {
        url: `https://backendpaygo.thetalent.games/gcp/isavailable/${bucketName}`,
        data: {},
        config: {
          headers: authHeader(),
        },
      };
      Axios.get(apiCall.url, apiCall.config, {})
        .then((res) => {
          let isavailable = res.data && res.data.available;
          setLoading(false);

          if (isavailable) {
            props.getStartedStep({ assessmentName, jobType, step: 2 });
          } else {
            setLoading(false);

            setErrorShow(true);
            setErrorMessage("Assessment game already exists!");
          }
        })
        .catch((err) => {
          setLoading(false);

          setErrorShow(true);
          setErrorMessage(err.message);
        });
    }
  };

  return (
    <>
      {upgrade ? (
        <UpgradeCard type="PREMIUM" onCloseUpgrade={onCloseUpgrade} />
      ) : (
        <div className="flex justify-center items-center">
          <div className="2xl:w-6/12 xl:w-7/12 lg:w-7/12 w-11/12">
            <div className="bg-white rounded-md shadow-lg  2xl:px-8 xl:px-8 lg:px-8 px-4 py-8 w-full">
              <div className="pb-6 flex flex-wrap justify-between  2xl:items-start xl:items-start lg:items-start  2xl:flex-row xl:flex-row lg:flex-row flex-col items-center">
                <div className="2xl:w-[48%] xl:w-[48%] w-11/12">
                  <div>
                    <h3 className="text-[#252B42]  text-lg font-semibold 2xl:text-left xl:text-left lg:text-left text-center ">
                      Name your assessment game
                    </h3>
                    <Input
                      name="assessmentNames"
                      customStyle={"h-12"}
                      placeholder="Enter assessment name here"
                      onChange={(e) => {
                        let val = e.target.value;
                        setAssessmentName(val);
                      }}
                      value={assessmentName}
                    />
                  </div>

                  <div className="flex flex-row flex-wrap items-center justify-start mt-8">
                    <InformationCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block hidden h-6 w-6 rounded-full mr-2 " />
                    <p className="text-[#282828] font-normal text-sm">
                      This name will be a part of your URL extension.
                    </p>
                    <div className="2xl:ml-9 xl:ml-9 lg:ml-9 ml-0">
                      <p className="text-[#282828] font-normal text-sm my-2">
                        <b>For eg:</b> if you type in XYZ Careers, then your
                        assessment game link will be:
                      </p>

                      <p className="text-[#007E8C] text-base">
                        www.xyzcareers.thetalent.games
                      </p>
                      <p className="text-[#282828] font-normal text-sm my-2">
                        Note: You can always contact us to get your game link
                        edited.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="2xl:w-[48%] xl:w-[48%] w-11/12 ">
                  <div>
                    <h3 className="text-[#252B42]  text-lg font-semibold  2xl:text-left xl:text-left lg:text-left text-center ">
                      Let us know whom you are hiring
                    </h3>
                    <Input
                      name="assessmentNames"
                      customStyle={"h-12"}
                      placeholder="Enter text here"
                      value={jobType}
                      onChange={(option) => handleChange(option)}
                    />
                  </div>

                  <div className="flex flex-row flex-wrap items-start justify-start mt-8">
                    <InformationCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block hidden h-6 w-6 rounded-full mr-2 " />
                    <p className="text-[#282828] font-normal text-sm">
                      Usually companies hire Interns, Management <br /> Trainees
                      or both.
                    </p>
                    <div className="2xl:ml-9 xl:ml-9 lg:ml-9 ml-0">
                      <p className="text-[#282828] font-normal text-sm my-2">
                        <b>For eg:</b> Interns, Management Trainees
                      </p>

                      <p className="text-[#282828] font-normal text-sm my-2">
                        Please use a comma to enter more than 1 type.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex mt-4  justify-center items-center">
                {errorShow ? (
                  <ErrorMessage
                    onClick={() => setErrorShow(false)}
                    customStyle="mx-auto"
                    text={errorMessage}
                  />
                ) : null}
              </div>
            </div>
            {/* Handle Next Button */}
            <div className="flex flex-row justify-between items-center my-10 ">
              <div></div>
              <div className="text-center ml-10">
                <h1 className="font-medium text-xl  text-[#3B4345]">
                  Your Current Plan:{" "}
                  <b className="font-bold text-xl text-[#007E8C]">PREMIUM</b>
                </h1>
              </div>
              <IconButton
                disabled={loading}
                onClick={handleNext}
                name={loading ? "Please Wait" : "Next"}
                customStyle="2xl:h-22 xl:h-22 h-12 2xl:px-10 xl:px-10 px-6 bg-[#007E8C] 2xl:text-lg xl:text-lg text-sm font-semibold  tracking-[0.1rem]"
              >
                <FaAngleRight className="text-white mt-1" />
              </IconButton>
            </div>
          </div>
        </div>
      )}
      <HelpButton screen="login" />
    </>
  );
};
const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { getStartedStep, getAllData })(
  GetStartedStep
);
